<template>
  <div class="user">
    <div class="photo">
      <img :src="picture ? picture : 'static/img/default-avatar.png'"/>
    </div>
    <div class="info">
      <a data-toggle="collapse" @click="toggleMenu" href="javascript:void(0)">
           <span>
             {{ name }}
             <b class="caret"></b>
          </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <el-collapse-transition>
          <ul class="nav" v-show="!isClosed">
            <router-link :to="{ name: 'ProfileEdit' }" tag="li">
              <a>
                <!-- <span class="sidebar-mini">P</span> -->
                <span class="sidebar-normal">Profil</span>
              </a>
            </router-link>
            <router-link :to="{ name: 'ProfileSettings' }" tag="li">
              <a>
                <!-- <span class="sidebar-mini">S</span> -->
                <span class="sidebar-normal">Paramètres</span>
              </a>
            </router-link>
            <li @click="signout" style="cursor: pointer;">
              <a>
                <!-- <span class="sidebar-mini">S</span> -->
                <span class="sidebar-normal">Déconnexion</span>
              </a>
            </li>
          </ul>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
  import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
  import firebase from 'firebase'

  export default {
    components: {
      [CollapseTransition.name]: CollapseTransition
    },
    data () {
      return {
        isClosed: true
      }
    },
    methods: {
      toggleMenu () {
        this.isClosed = !this.isClosed
      },
      signout () {
        firebase.auth().signOut()
          .then(() => {
            this.$router.push('/login')
          }).catch((error) => console.error(error))
      }
    },
    computed: {
      name () {
        return firebase.auth().currentUser.displayName
      },
      picture () {
        return firebase.auth().currentUser.photoURL
      }
    }
  }
</script>
<style>
  .collapsed {
    transition: opacity 1s;
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/UserMenu.vue